import * as React from "react";
import type { SVGProps } from "react";
const SvgGift = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21 8h-3.718c.166-.39.258-.82.258-1.27 0-1.8-1.47-3.27-3.27-3.27-.656 0-1.268.194-1.78.528A3.924 3.924 0 0 0 9.08 2h-.16C6.76 2 5 3.76 5 5.92v.16c0 .697.183 1.352.504 1.92H3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h1v7c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-7h1c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1ZM4 10v2h7v-2H4Zm9 0v2h7v-2h-7Zm-2 4H6v6h5v-6Zm2 6v-6h5v6h-5Zm2.54-13.27c0 .699-.568 1.268-1.266 1.27H13V6.73c0-.7.57-1.27 1.27-1.27.7 0 1.27.57 1.27 1.27ZM11 5.92V8H8.92A1.92 1.92 0 0 1 7 6.08v-.16C7 4.86 7.86 4 8.92 4h.16C10.14 4 11 4.86 11 5.92Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgGift;
